import React from "react";
import Block from "./Block";
import { styled } from "../stitches.config";
import { blockYouJustCreatedAtom } from "../jotai/atoms";
import { useAtom } from "jotai";
import { useBlocks } from "../liveblocks/maps";
import useSelectionPresence from "../ui/selection/useSelectionPresence";

function BlockList() {
  const { deleteBlock, upsertBlock, blocks, clients } = useBlocks();
  const [justCreated] = useAtom(blockYouJustCreatedAtom);
  const selectionColors = useSelectionPresence();

  if (!blocks || !clients) return null;

  return (
    <BlockWrapper>
      {Object.keys(blocks).map((id: string) => {
        const selection = selectionColors[id];
        const liveblock = clients.get(id);
        if (!liveblock) return null;

        return (
          <Block
            key={id}
            liveBlock={liveblock}
            selectionColor={selection}
            justCreated={justCreated === id}
            upsertBlock={upsertBlock}
            deleteBlock={deleteBlock}
          ></Block>
        );
      })}
    </BlockWrapper>
  );
}

export default React.memo(BlockList);

const BlockWrapper = styled("ul", {
  position: "absolute",
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  pointerEvents: "none", // remove hack later
});
